import { clientsTypes } from "../constants/action-types"

import { getFirmsCustomerByCuitCorpEntities } from "../../app/services/Clients/getFirmsCustomerByCuitCorpEntities"
export const suborganizationAsocSuccess = (data) => {
  return {
    type: clientsTypes.CLIENTS_GET_FIRMS_CUSTOMER,
    payload: data,
  }
}

export const getFirmsCustomer = (cuitCliente) => {
  return async (dispatch) => {
    try {
      const response = await getFirmsCustomerByCuitCorpEntities(cuitCliente)
      dispatch(suborganizationAsocSuccess(response?.data))

      return response?.data?.data
    } catch (error) {
      console.log(error)
    }
  }
}
